<template>
  <v-app class="info-monitor">
    <v-img
      contain
      max-height="180"
      class="pink--text"
      :src="require('../assets/virtuaalijono.svg')"
    ></v-img>
    <h2>Vuorossa numero</h2>
    <div v-if="currentSlot !== null" class="slot">{{ currentSlot.slotID }}</div>
    <div v-if="currentSlot === null" class="no_slot">…</div>
  </v-app>
</template>

<script>
import 'es6-promise/auto';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Info',
  components: {},
  computed: mapGetters(['currentSlot']),
  beforeMount: function() {
    this.refreshQueueSlots();
  },
  methods: {
    ...mapActions(['refreshQueueSlots']),
    goBack: function() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.info-monitor {
  text-align: center;
}
h1 {
  font-size: 10vh;
}
h2 {
  font-size: 3vh;
  font-weight: 700;
  margin: 4vh 0;
  text-transform: uppercase;
}
.slot {
  font-size: 50vh;
  font-weight: 900;
  line-height: 50vh;
  margin: 0;
  padding: 0;
}
.no_slot {
  margin-top: 10vh;
  font-size: 10vh;
}
</style>
